import { createAsyncThunk } from '@reduxjs/toolkit';
import { MonitoringSummaryDto } from '@kortxio/hub-api';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export type GetMonitoringSummaryArgs = {
  activeSince: string;
  asOf: string;
};

export const getMonitoringSummary = createAsyncThunk<
  MonitoringSummaryDto,
  GetMonitoringSummaryArgs,
  AsyncThunkConfig
>(
  'monitoringCommandCenter/getMonitoringSummary',
  async ({ activeSince, asOf }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.monitorSummary.getMonitoringSummary(
        activeSince,
        asOf
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
